import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_pointlistv2 = _resolveComponent("pointlistv2");
  return _openBlock(), _createElementBlock("div", {
    class: "mapContainer",
    style: _normalizeStyle($data.mainStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass(`formUserId${$data.formUserId}`),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $props.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapculturalList,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "streetcode", "pointlist", "culturallist", "onSingleclick", "onMarkerclick", "onMarkermoveend"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["ulWrap", {
      'show': $data.ydtypelistflag
    }])
  }, [_createElementVNode("div", {
    class: "ulwraptop",
    onClick: _cache[0] || (_cache[0] = $event => $data.ydtypelistflag = false)
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
    _: 1
  })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "ulitem"
    }, [_createElementVNode("label", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("ul", {
      class: _normalizeClass(`typeul${index}`)
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.itemformdata.children, (child, ids) => {
      return _openBlock(), _createElementBlock("li", {
        key: ids,
        class: _normalizeClass({
          'on': child.flag
        }),
        onClick: $event => $options.typeClick(item, index, child)
      }, _toDisplayString(child.title), 11, _hoisted_5);
    }), 128))], 2)]);
  }), 128))], 2), _createElementVNode("div", {
    class: "ydtypebtn",
    onClick: _cache[1] || (_cache[1] = $event => $data.ydtypelistflag = true)
  }, [...(_cache[3] || (_cache[3] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/f66ffc624cd4b47dc98c64d5ea917ddd.png",
    alt: ""
  }, null, -1)]))]), _createVNode(_component_mappopupv2, {
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobile,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: "golist",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.golist,
    alt: ""
  }, null, 8, _hoisted_6)], 512), [[_vShow, $data.showgolist]]), $data.cTemplateScore === 1 ? (_openBlock(), _createBlock(_component_pointlistv2, {
    key: 1,
    listshowflag: $data.form.showlist,
    formoption: $data.cformoption,
    datalist: $data.mapculturalList,
    modeltype: $props.style.listStyleIndex,
    style: _normalizeStyle($data.modulestyle.list),
    onListclick: $options.pointlistClick
  }, null, 8, ["listshowflag", "formoption", "datalist", "modeltype", "style", "onListclick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, null, 512)], 2)], 4);
}